module.exports = __webpack_public_path__ + "img/powered_by_stripe.3e0cf333.svg";